export default __webpack_public_path__ + "static/media/backgroundcard.f1c4f7c0.png";